// @ts-nocheck
import styled from 'styled-components';
import { getTheme } from 'settings/theme';
import type { StatelessFunctionalComponent } from 'react';

import MaterialCard from 'components/MaterialCard';
import NooderaButton from 'components/NooderaButton';

const {
  noodera: { fontTypes, spacing },
} = getTheme();

export const SMaterialCard: StatelessFunctionalComponent<any> = styled(MaterialCard)`
  ${({ type, theme }) =>
    type === 'warning'
      ? `background-color: ${theme.palette.warning.ten}`
      : `background-color: ${theme.palette.primary.ten}`};
  display: flex;
  flex-direction: row;
  padding: ${spacing.x5};
  height: fit-content;
  ${({ width }) => width && `width: ${width}`};
  ${({ marginBottom, theme }) => marginBottom && `margin-bottom: ${theme.noodera.spacing.x4}`};
`;

export const MobileBreadcrumbContainer: StatelessFunctionalComponent<any> = styled.span`
  ${(props) => props.theme.underlineLink}
`;

export const IconWrapper: StatelessFunctionalComponent<any> = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: ${spacing.x5};

  & svg {
    width: 32px;
    height: 32px;
  }

  & path {
    fill: ${({ theme, type }) =>
      type === 'warning' ? theme.palette.warning.hundred : theme.palette.primary.hundred};
  }
`;

export const STitle: StatelessFunctionalComponent<any> = styled.h4`
  ${fontTypes.font4Medium};
  color: ${({ theme }) => theme.palette.neutral.hundred};
`;

export const SContent: StatelessFunctionalComponent<any> = styled.div`
  ${fontTypes.font4};
  color: ${({ theme }) => theme.palette.neutral.hundred};
`;

export const SNoodleBtn: StatelessFunctionalComponent<any> = styled(NooderaButton)`
  background-color: ${({ type, theme }) =>
    type === 'warning' ? `background-color: ${theme.palette.warning.hundred}` : ''};
`;
